import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchData, updateLastLogin } from '../api/github';
import { checkPassword } from '../utils/auth';
import InstallPrompt from '../components/InstallPrompt';
import { TextField, Button, Container, Typography } from '@mui/material';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('isAuth')) {
      const role = localStorage.getItem('userRole');
      navigate(role === 'admin' ? '/admin' : '/employee', { replace: true });
    }
  }, [navigate]);

  const handleLogin = async () => {
    const employees = await fetchData('employees.json');
    const user = employees.find(e => e.username === username && checkPassword(password, e.password));
    if (user && checkPassword(password, user.password)) {
      localStorage.setItem('isAuth', 'true');
      localStorage.setItem('userName', user.username);
      localStorage.setItem('userRole', user.role);
      localStorage.setItem('userId', user.id); // Сохраняем ID пользователя
      
      // Обновляем время последнего входа
      await updateLastLogin(user.id);
      
      navigate(user.role === 'admin' ? '/admin' : '/employee', {replace: true});
    } else {
      alert('Логин йоки пароль нотоғри');
    }
  };

  return (
    <Container maxWidth="sm" sx={{mt: 5}}>
     <InstallPrompt />
      <Typography variant="h4">Кириш</Typography>
      <TextField
        label="Логин"
        fullWidth
        margin="normal"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        label="Пароль"
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button onClick={handleLogin} fullWidth variant="contained">Кириш</Button>
    </Container>
  );
}